/**
 * Application bootstrap entry point.
 *
 * Loads the runtime configuration (public/config.json or config.dev.json)
 * BEFORE any application code is imported. This is critical because
 * service constructors (e.g. LoggerService) call getRuntimeConfig()
 * at module-load time, so the config must already be available.
 */
import { loadRuntimeConfig } from '@src/config/runtime-config';

loadRuntimeConfig()
  .then(() => import('./main'))
  .catch((error) => {
    const fallbackDiv = document.createElement('div');
    fallbackDiv.innerHTML = `
      <div style="padding: 20px; text-align: center; color: #721c24; background-color: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px; margin: 20px;">
        <h2>Failed to Load Configuration</h2>
        <p>The application could not load its configuration. Please try refreshing the page.</p>
        <details style="margin-top: 10px;">
          <summary>Technical Details</summary>
          <pre style="text-align: left; margin-top: 10px; font-size: 12px;">${error instanceof Error ? error.message : String(error)}</pre>
        </details>
      </div>
    `;
    document.getElementById('root')?.appendChild(fallbackDiv);
  });
